import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/styles";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Avatar,
  CircularProgress,
  Typography,
} from "@material-ui/core";
import RTL from "../../../../components/RTL";
import mockData from "./data";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import VisibilityIcon from "@material-ui/icons/Visibility";
import Pagination from "@material-ui/lab/Pagination";
import Supervisor from "views/Supervisor";
import { Loading } from "redux/Action";
import { useDispatch, useSelector } from "react-redux";
import { axios } from "./../../../../axios";
import { SearchInput } from "components";

const useStyles = makeStyles((theme) => ({
  imageContainer: {
    width: 140,
    height: 140,
    margin: "auto",
    position: "relative",
    overflow: "unset",
  },
  searchInput: {
    padding: theme.spacing(2),
  },
  avatar: {
    width: 30,
    height: 30,
    margin: "auto",
  },
  imageButton: {
    position: "absolute",
    left: -15,
    bottom: -10,
  },
  image: {
    width: 110,
    height: 110,
  },
  input: {
    marginTop: theme.spacing(4),
  },
  imageInput: {
    display: "none",
  },
  submitButtonIcon: {
    marginLeft: theme.spacing(2),
  },
}));
let filter_txt = "";

const EmployeeList = (props) => {
  const classes = useStyles();
  const { onDelete, onEdit, ChangeId, del, edit, reload, selData } = props;
  let Pr_inventory = useSelector((state) => state.permission);
  const current_role = useSelector((state) => state.role);

  const token = useSelector((state) => state.token);
  const [data, setData] = React.useState([]);
  const [LastPage, setLastPage] = React.useState(1);
  const [Page, setPage] = React.useState(1);
  const [filter, setFilter] = React.useState("");
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.isLoading);
  const handleChangePage = (event, value) => {
    setPage(value);
  };

  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const GetData = async () => {
    try {
      const res = await axios.get(
        `staff?full_name=${filter_txt}&page=${Page}`,
        {
          headers: headers,
        }
      );
      setLastPage(res.data.users.last_page);
      if (LastPage == 1) {
        setPage(1);
      }
      setData(res.data.users.data);
      dispatch(Loading());
    } catch (e) {
      dispatch(Loading());
    }

    //alert(res)
  };

  useEffect(() => {
    dispatch(Loading());
    GetData();
  }, [Page, reload]);

  const handleKeyDown = (event) => {
    setPage(1);
    if (event.key === "Enter") {
      filter_txt = event.target.value;
      setData([]);
      GetData();
      dispatch(Loading());
    }
  };

  return (
    <RTL>
      <>
        <div className={classes.searchInput}>
          <SearchInput
            onKeyDown={handleKeyDown}
            placeholder="نام شخص مورد نظر را جستجو کنید"
          />
        </div>
        {!isLoading ? (
          <>
            {data ? (
              data.length > 0 ? (
                <TableContainer className={classes.tableContainer}>
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell align="center">نام و نام خانوادگی</TableCell>
                        <TableCell align="center">نام شرکت</TableCell>
                        <TableCell align="center">عنوان شغل</TableCell>
                        <TableCell align="center"> شماره تماس</TableCell>
                        {current_role == "Super-Admin" ||
                        Pr_inventory.indexOf("staff.remove") != -1 ||
                        Pr_inventory.indexOf("staff.edit") != -1 ? (
                          <TableCell align="center" sortDirection="desc">
                            عملیات
                          </TableCell>
                        ) : (
                          ""
                        )}
                      </TableRow>
                    </TableHead>
                    <TableBody className={classes.tableBody}>
                      {data.map((data_employee) => (
                        <TableRow hover key={data_employee.id}>
                          <TableCell align="center">
                            {data_employee.user?.full_name}
                          </TableCell>
                          <TableCell align="center">
                            {data_employee.company?.name}
                          </TableCell>
                          <TableCell align="center">
                            {data_employee.user?.roles?.length > 0
                              ? data_employee.user?.roles.map(
                                  (element, index) => {
                                    if (
                                      data_employee.user?.roles?.length ==
                                      index + 1
                                    ) {
                                      return element.alias_title;
                                    } else {
                                      return element.alias_title + " ، ";
                                    }
                                  }
                                )
                              : "-"}
                          </TableCell>
                          <TableCell align="center">
                            {data_employee.user?.cell}
                          </TableCell>
                          {current_role == "Super-Admin" ||
                          Pr_inventory.indexOf("staff.remove") != -1 ||
                          Pr_inventory.indexOf("staff.edit") != -1 ? (
                            <TableCell align="center">
                              {current_role == "Super-Admin" ||
                              Pr_inventory.indexOf("staff.edit") != -1 ? (
                                <IconButton
                                  disabled={edit || del}
                                  style={
                                    edit || del
                                      ? { color: "#7f8c8d" }
                                      : { color: "#6c5ce7" }
                                  }
                                  onClick={() => {
                                    onEdit();
                                    ChangeId(data_employee.id);
                                  }}
                                  color="error"
                                  aria-label="upload picture"
                                  component="span"
                                >
                                  <EditIcon />
                                </IconButton>
                              ) : (
                                ""
                              )}
                              {current_role == "Super-Admin" ||
                              Pr_inventory.indexOf("staff.remove") != -1 ? (
                                <IconButton
                                  disabled={edit || del}
                                  style={
                                    edit || del
                                      ? { color: "#7f8c8d" }
                                      : { color: "#E65D62" }
                                  }
                                  onClick={() => {
                                    onDelete();
                                    ChangeId(data_employee.id);
                                    selData(
                                      data
                                        .filter(
                                          (dt) => dt.id == data_employee.id
                                        )
                                        .map((filterData) => filterData)
                                    );
                                  }}
                                  color="error"
                                  aria-label="upload picture"
                                  component="span"
                                >
                                  <DeleteIcon />
                                </IconButton>
                              ) : (
                                ""
                              )}
                            </TableCell>
                          ) : (
                            ""
                          )}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>

                  {LastPage > 1 ? (
                    <Pagination
                      style={{ margin: 10 }}
                      variant="outlined"
                      onChange={handleChangePage}
                      page={Page}
                      count={LastPage}
                      color="primary"
                    />
                  ) : (
                    ""
                  )}
                </TableContainer>
              ) : (
                <div
                  style={{
                    display: "flex",
                    flex: 1,
                    alignItems: "center",
                    padding: 50,

                    height: "100%",
                    justifyContent: "center",
                  }}
                >
                  <Typography>متاسفانه هیچ رکوردی یافت نشد</Typography>
                </div>
              )
            ) : (
              ""
            )}
          </>
        ) : (
          <div
            style={{
              display: "flex",
              flex: 1,
              alignItems: "center",
              height: "100%",
              justifyContent: "center",
            }}
          >
            <CircularProgress size={24} />
          </div>
        )}
      </>
    </RTL>
  );
};

export default EmployeeList;
